import React from "react";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import Stromnetz from "./Views/stromnetze/Stromnetz";
import RohrgefuehrteMedien from "./Views/rohrgefuehrteMedien/RohrgefuehrteMedien";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route 
          path="/Stromnetz" 
          element={<Stromnetz />}>            
        </Route>
        <Route
          path="/RohrgefuehrteMedien"
          element={<RohrgefuehrteMedien />}
        ></Route>
      </Routes>
    </div>
  );
}

export default App;
